import {BMTheme} from "../../BMTheme";

const loginStyle = {
  main: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    minHeight: "100vh",
    backgroundColor: BMTheme.login.backgroundColor
  },

  logo: {
    display: "flex",
    flex: 0.35,
    alignItems: "flex-end",
    justifyContent: "center",
    image: {
      maxHeight: "25vh"
    }
  },

  login: {
    flex: 0.2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    marginTop: "3%"
  },

  formContainer: {
    display: "flex",
    flex: 0.4,
    flexDirection: "column",
    justifyContent: "space-between",
    width: "75%",
    textFieldAndroid: {
      backgroundColor: BMTheme.login.form.textFieldAndroid.backgroundColor,
      height: "2.6rem",
      width: "100%",
      marginBottom: "0.7rem",
      paddingLeft: "4%",
      paddingRight: "4%",
      fontSize: "90%"
    },
    textFieldElse: {
      backgroundColor: BMTheme.login.form.textFieldElse.backgroundColor,
      height: "7vh",
      width: "100%",
      marginBottom: "1%",
      paddingLeft: "4%",
      paddingRight: "4%",
      fontSize: "90%"
    }
  },

  button: {
    maxHeight: "7vh",
    buttonAndroidStyle: {
      height: "2.6rem"
    },
    buttonElseStyle: {
      height: "7vh"
    },
    buttonOverlayStyle: {
      backgroundColor: "transparent"
    },
    buttonLabelStyle: {
      fontSize: "120%",
      textTransform: "sentencecase",
      fontWeight: "bold"
    }
  },

  errorStyle: {
    marginTop: "1%"
  },

  underlineStyle: {
    display: "none"
  },

  hintContainer: {
    display: "flex",
    alignItems: "flex-start",
    flex: 0.35
  },

  hint: {
    textAlign: "center",
    color: BMTheme.login.form.hintColor,
    fontSize: "80%"
  },

  footerContainer: {
    display: "flex",
    alignItems: "flex-start",
    flex: 0.1
  },

  footer: {
    textAlign: "center",
    color: BMTheme.login.form.footerColor,
    fontSize: "100%"
  },

  androidFooter: {
    textAlign: "center",
    color: BMTheme.login.form.footerColorAndroid,
    fontSize: "100%",
    paddingBottom: "2.5rem"
  }
};

export default loginStyle;



// WEBPACK FOOTER //
// ./src/containers/Login/style.js